// extracted by mini-css-extract-plugin
export default {"details":"MainCartItem_details__X6hlb","quantity":"MainCartItem_quantity__bEYEb","subtotal":"MainCartItem_subtotal__wgaCs"};